<p>verify-msme-view works!</p>
